import {
    FormField
} from "@maysoft/common-component-react"
import {
    Stack,
    Typography,
    Grid,
    Paper
} from "@mui/material"

type Props = {
    value: any
    onChange: (val: any) => void
}

const FirebaseConfigForm = ({ value, onChange }: Props) => {

    const handleChange = (
        section: string | null,
        key: string,
        val: string
    ) => {
        if (section) {
            onChange({
                ...value,
                [section]: {
                    ...value[section],
                    [key]: val
                }
            })
        } else {
            onChange({
                ...value,
                [key]: val
            })
        }
    }

    const formatLabel = (key: string) => {
        return key
            .replace(/_/g, " ")
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (str) => str.toUpperCase())
    }

    const renderField = (
        key: string,
        val: any,
        section: string | null = null
    ) => {
        const isLongText =
            typeof val === "string" &&
            (val.length > 80 || key.includes("key"))

        const isFullWidth =
            key.includes("private_key") ||
            key.includes("vapidKey")

        return (
            <Grid item xs={12} md={(isFullWidth || isLongText) ? 12 : 6}>
                <FormField
                    fullWidth
                    label={formatLabel(key)}
                    value={val || ""}
                    multiline={isLongText}
                    minRows={isLongText ? 4 : 1}
                    type={key.includes("key") ? "password" : "text"}
                    onChangeValue={(v) =>
                        handleChange(section, key, v)
                    }
                />
            </Grid>
        )
    }

    return (
        <Stack spacing={3}>
            {Object.entries(value || {}).map(([key, val]) => {

                // object section
                if (typeof val === "object" && val !== null) {
                    return (
                        <Paper
                            key={key}
                            sx={{
                                p: 2,
                                borderRadius: 2
                            }}
                        >
                            <Typography
                                fontWeight={700}
                                fontSize={16}
                                mb={2}
                            >
                                {formatLabel(key)}
                            </Typography>

                            <Grid container spacing={2}>
                                {Object.entries(val).map(
                                    ([childKey, childVal]) =>
                                        renderField(childKey, childVal, key)
                                )}
                            </Grid>
                        </Paper>
                    )
                }

                // root field
                return (
                    <Paper
                        key={key}
                        sx={{
                            p: 2,
                            borderRadius: 2
                        }}
                    >
                        <Typography
                            fontWeight={700}
                            fontSize={16}
                            mb={2}
                        >
                            {formatLabel(key)}
                        </Typography>
                        <Grid container spacing={2}>
                            {renderField(key, val)}
                        </Grid>
                    </Paper>
                )
            })}
        </Stack>
    )
}

export default FirebaseConfigForm